<template>

    <div>
        <el-row>
            <div class="left-justifying"><h3>机房监察</h3></div>

            <div class="right-justifying">
                <el-button v-if="addBtnVisible && canOper" @click="btnNewClickHandle()" type="info" plain size="small">
                    <i class="fa fa-plus-circle"></i> 新建
                </el-button>
                <el-button v-if="modiBtnVisible && canOper && !isInWorkflow" @click="btnModiClickHandle()" type="info" plain size="small">
                    <i class="fa fa-pencil"></i> 修改
                </el-button>
                <el-button v-if="cancelVisible && canOper && !isInWorkflow" @click="btnCancelClickHandle()" type="info" plain size="small">
                    <i class="fa fa-pencil"></i> 取消
                </el-button>
                <el-button v-if="saveBtnVisible && canOper && !isInWorkflow" @click="btnSaveClickHandle()" type="info" plain size="small">
                    <i class="fa fa-save"></i> 保存
                </el-button>
                <el-button v-if="delBtnVisible && canOper && !isInWorkflow" @click="btnDelClickHandle()" type="info" plain size="small">
                    <i class="fa fa-times"></i> 删除
                </el-button>
                <WorkflowRequestBtn :visible="workflowBtnVisible && assessmentDetail.status != 'CLOSE'"
                                    bussiness="INSPECT"
                                    :bussinessId="assessmentDetail.id"
                                    :bussinessInfo="bussinessInfo"
                                    :errorMsg="workFlowErrorMsg"
                                    @afterRequestWorkflowFunc="afterRequestWorkflowFunc">
                </WorkflowRequestBtn>
                <WorkflowReopenBtn :visible="workflowBtnVisible && assessmentDetail.status == 'CLOSE' && canReOpen"
                                   bussiness="INSPECT"
                                   :bussinessId="assessmentDetail.id"
                                   :bussinessInfo="bussinessInfo"
                                   :disabled="false"
                                   @afterRequestWorkflowFunc="afterRequestWorkflowFunc">
                </WorkflowReopenBtn>
            </div>

        </el-row>

        <div class="panel">
            <div class="panel-body">

                <el-row>
                    <div class="advanced-search-location">

                        <AthubDropDownSearch :model="searchParams" :formWidth="800" v-if="dropDownVisible" size="mini"
                                             collapseTags multiple>
                            <el-form :model="search" label-width="80px">
                                <el-row type="flex" class="row-bg">
                                    <el-col :span="11">
                                        <el-form-item label="考核月份从">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.startdate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="考核月份从">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-form-item label="考核月份至">
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.enddate"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="考核月份至">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </AthubDropDownSearch>
                        <el-tag v-if="workflowStatusVisible" type="danger" size="mini" style="margin-top: 9px;">
                            {{assessmentDetail.status | workflowStatusLabelFilter}}
                        </el-tag>

                    </div>

                    <el-tabs v-model="activeTab" @tab-click="handle_tab_click">
                        <el-tab-pane label="列表" name="tab_1">

                            <el-row class="bottom20">
                                <el-table :data="tableData" highlight-current-row>
                                    <el-table-column prop="assessmentobj" label="考核对象">
                                        <template slot="header" slot-scope="scope">
                                            考核对象<br>
                                            <dept-select size="mini" ref="deptSelectTable" allowAll="true" :multiple=true
                                                         v-model="searchParams.assessmentobjs">
                                            </dept-select>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button @click="queryDetail(scope.row.id)" type="text" size="mini">
                                                {{scope.row.assessmentobj | deptFilter}}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="month" :formatter="formatMonth" label="考核时段">
                                        <template slot="header" slot-scope="scope">
                                            考核时段
                                            <el-date-picker
                                                    size="mini"
                                                    v-model="searchParams.month"
                                                    type="month"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="考核时段"> </el-date-picker>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="totalscore" label="最终得分">
                                        <template slot="header" slot-scope="scope">
                                            最终得分<br><br><br>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="status" label="状态">
                                        <template slot="header" slot-scope="scope">
                                            状态<br>
                                            <dictionary-select v-model="searchParams.status" :factory-name="'domain'"
                                                               :params="'ASSESSMENTSTATUS'" filterable clearable
                                                               size="mini" ref="assessmentStatus" @loaded="assessmentStatusLoaded"></dictionary-select>
                                        </template>
                                        <template slot-scope="scope">
                                            <dictionary-text :factory-name="'domain'" :params="'ASSESSMENTSTATUS'"
                                                             :value="scope.row.status"></dictionary-text>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-row>

                            <el-row type="flex" class="row-bg" justify="end">
                                <el-pagination align="right" @size-change="handleSizeChange"
                                               @current-change="handleCurrentChange"
                                               :current-page="currentPage"
                                               :page-sizes="pageSizes" :page-size="pageSize"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="total">
                                </el-pagination>
                            </el-row>

                        </el-tab-pane>
                        <el-tab-pane label="评分汇总" name="tab_2">
                            <div class="panel-body">

                                <el-form label-position="right" :model="assessmentDetail" ref="assessmentDetailForm" label-width="120px" :rules="rules">
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="考核对象" prop="assessmentobj">
                                                <dept-select v-model="assessmentDetail.assessmentobj" class="width70" @input="assessmentObjChangeFunc"
                                                             size="small" :disabled=formDisable>
                                                </dept-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="考核时段" prop="month">
                                                <el-date-picker
                                                        size="small"
                                                        v-model="assessmentDetail.month"
                                                        align="right"
                                                        type="month"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择日期"
                                                        :picker-options="pickerOptions"
                                                        class="width70"
                                                        :disabled=formDisable
                                                        @change="monthChangeFunc">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item>
                                            <span slot="label">
                                                <span class="span-box">
                                                    <span>容量系数</span>
                                                    <i class="el-icon-question blue" style="cursor:pointer"
                                                       @click="showCapacityDialog"></i>
                                                </span>
                                            </span>
                                                <el-input v-model="assessmentDetail.capacityratio" disabled class="width70"
                                                          size="small"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item>
                                                <span slot="label">
                                                    <span class="span-box">
                                                        <span>成长系数</span>
                                                        <i class="el-icon-question blue" style="cursor:pointer"
                                                           @click="showGrowupDialog"></i>
                                                    </span>
                                                </span>
                                                <el-input v-model="assessmentDetail.growupratio" disabled class="width70"
                                                          size="small"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item>
                                                <span slot="label">
                                                    <span class="span-box">
                                                        <span>最终得分</span>
                                                           <el-tooltip :content="resultScoreContent" placement="top">
                                                              <i class="el-icon-question blue" style="cursor:pointer"></i>
                                                           </el-tooltip>
                                                    </span>
                                                </span>
                                                <el-input v-model="totalscore" class="width70"
                                                          size="small" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="监察表版本">
                                                <el-input v-model="assessmentDetail.version" class="width70"
                                                          size="small" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="评分人">
                                                <el-input v-model="assessmentDetail.dealperson" class="width70"
                                                          size="small" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="评分时间">
                                                <el-input v-model="assessmentDetail.dealdate" class="width70"
                                                          size="small" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>

                                <el-row class="column-name" justify="start">
                                    <span>分项评分得分</span>
                                    <div class="navbar-right">
                                        得分： {{level1TableTotal}}
                                    </div>
                                </el-row>
                                <assessment-record-level1-table ref="assessmentLevel1Table"
                                                                :assessmentid="assessmentDetail.id"
                                                                @afterQueryAssessmentRecordLevel1Table="afterQueryAssessmentRecordLevel1Table"></assessment-record-level1-table>

                                <el-row class="column-name" justify="start">
                                    <span>加减分项评分得分</span>
                                    <div class="navbar-right">
                                        得分： {{addsubTotal}}
                                    </div>
                                </el-row>
                                <addsub-record-collect-table ref="addsubRecordCollectTable" :addValue="addValueFunc()" :subValue="subValueFunc()"></addsub-record-collect-table>

                                <el-row class="column-name" justify="start" v-if="assessmentDetail.id != ''">
                                    <span>流转信息</span>
                                </el-row>
                                <el-row v-if="assessmentDetail.id != ''">
                                    <Workflow
                                            ref="assessmentWorkflowInfo" bussiness="INSPECT"
                                            :bussinessId="assessmentDetail.id">
                                    </Workflow>
                                </el-row>

                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="分项评分" name="tab_3">
                            <assessment-record-level2-table ref="assessmentLevel2Table" :assessmentid="assessmentDetail.id"
                                                            @afterUpdateAssessmentRecord="afterUpdateAssessmentRecord" :canOper="canOper && !isInWorkflow"></assessment-record-level2-table>
                        </el-tab-pane>
                        <el-tab-pane label="加、减分项" name="tab_4">
                            <addsub-record-table ref="addTable" :tableData="addRecordTableData" type="add"
                                                 @afterUpdateAddsubRecord="afterUpdateAddsubRecord" :canOper="canOper && !isInWorkflow"></addsub-record-table>
                            <addsub-record-table ref="subTable" :tableData="subRecordTableData" type="sub"
                                                 @afterUpdateAddsubRecord="afterUpdateAddsubRecord" :canOper="canOper && !isInWorkflow"></addsub-record-table>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>

            </div>

        </div>

        <capacity ref="capacityRef" :capacityDialogVisible.sync="capacityDialogVisible"></capacity>
        <growup ref="growupRef" :growupDialogVisible.sync="growupDialogVisible"></growup>

        <WorkflowDialog
                bussiness="ASSESSMENT"
                statusName="athubStatus"
                ref="workflowDialog"
                :bussinessId="assessmentDetail.id"
                :workflowRequestInfo="workflowRequestInfo"
                :dialogWorkflowVisible.sync="workflowDialogVisible"
                @afterAuditWorkflowFunc="afterAuditWorkflowFunc">
        </WorkflowDialog>

    </div>

</template>

<script>
import assessmentVersionStatus from "./mixins/assessmentVersionStatus";
import DeptMixins from '../../mixins/dept';
import DeptSelect from '@/components/dept'
import DictionarySelect from '@/components/common/DictionarySelect'
import DictionaryText from '@/components/common/DictionaryText'
import AssessmentServer from "../../api/assessment";
import {debounce} from "../../util/common";
import AssessmentRecordLevel1Table from './record/assessmentRecordLevel1Table'
import AssessmentRecordLevel2Table from './record/assessmentRecordLevel2Table'
import AddsubRecordCollectTable from './addsubRecord/addsubRecordCollectTable'
import AddsubRecordTable from './addsubRecord/addsubRecordTable'
import Capacity from './capacity/capacity'
import Growup from './growup/growup'
import {formatDate} from 'element-ui/src/utils/date-util'
import DateUtil from '@/util/common/date'
import AthubCloudApi from "../../api/athubCloud";
import {ASSESSMENT_PERMISSION, getCapacityRatioOper} from './assessment_common'

import AthubDropDownSearch from '@/components/common/athub.dropdown.search'

import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
import WorkflowReopenBtn from '@/components/workflow/workflowReopenBtn'
import WorkflowDialog from '@/components/workflow/workflowDialog'
import Workflow from '@/components/workflow'
import DomainalnApi from "@/api/domainaln";

let that;

    export default {
        name: "check",

        mixins: [assessmentVersionStatus, DeptMixins],

        components: {
            DeptSelect,
            DictionarySelect,
            DictionaryText,
            AssessmentRecordLevel1Table,
            AssessmentRecordLevel2Table,
            AddsubRecordCollectTable,
            AddsubRecordTable,
            Capacity,
            Growup,

            AthubDropDownSearch,

            WorkflowRequestBtn,
            WorkflowReopenBtn,
            WorkflowDialog,
            Workflow,

        },

        data() {
            return {

                activeTab: 'tab_1',

                dropDownVisible: true,
                addBtnVisible: true,
                modiBtnVisible: false,
                cancelVisible: false,
                saveBtnVisible: false,
                delBtnVisible: false,
                workflowBtnVisible: false,

                formDisable: true,

                addValue: 0,
                subValue: 0,

                //最终得分公式及计算过程
                resultScoreContent: '',

                searchParams: {
                    ids: [],
                    startdate: '',
                    enddate: '',
                    assessmentobjs: [],
                    status: '',
                },

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],

                tableData: [],
                total: 0,

                assessmentDetail: {
                    id: -1,
                    assessmentobj: '',
                    month: '',
                    capacityratio: '',
                    growupratio: '',
                    totalscore: '',
                    version: '',
                    dealperson: '',
                    dealdate: '',
                    validation: 'VALID',
                    status: '',
                },

                rules: {
                    assessmentobj: [
                        {required: true, message: '请选择部门', trigger: 'change'},
                    ],
                    month: [
                        {required: true, message: '请选择日期', trigger: 'change'}
                    ]
                },

                pickerOptions: {
                    disabledDate(time) {
                        return !(time.getMonth() == 2 || time.getMonth() == 5 || time.getMonth() == 8 || time.getMonth() == 11);
                    },
                },

                addRecordTableData: [],
                subRecordTableData: [],

                addsubTotal: 0,

                capacityDialogVisible: false,
                growupDialogVisible: false,

                level1TableTotal: 0,

                assessmentStatusDictionary: {},

                canOper: true,  //是否职位有权限

                isInWorkflow: true,      //是否进工作流（进工作流不允许修改）

                //工作流相关
                workflowBtnVisible: true,

                workflowDialogVisible: false,

                bussinessInfo: {},  //请求工作流附加的一些参数，在保存、修改时都需要上送

                workFlowErrorMsg: '',

                workflowRequestInfo: {},    //审批工作流时包含请求工作流返回的结果：后一节点，wfToken

                canReOpen: true, //是否可以重新审核

                //列表页面工作流状态
                workflowStatusVisible: true,

                //列表页面高级查询框
                dropDownVisible: true,
            }
        },

        methods: {

            handle_tab_click(tab, event) {
                this.activeTab = tab.name;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            async queryTable() {
                let pageParams = {
                    'currentPage': this.currentPage,
                    'pageSize': this.pageSize,
                }

                if (this.searchParams.assessmentobjs == null || this.searchParams.assessmentobjs.length == 0) {
                    let deptInfo = await AthubCloudApi.fetchDeptListByAuthSites();
                    pageParams.assessmentobjs = deptInfo.map(e => e.id);
                }

                let params = {
                    ...this.searchParams, ...pageParams, ...{'validation': 'VALID'}
                };
                await AssessmentServer.assessment.page(params, {
                    headers: {
                        orgId: localStorage.getItem("authorg"),
                        sites: localStorage.getItem("authsites"),
                    }
                }).then(res => {
                    this.tableData = res.data.data.pageData;
                    this.total = res.data.data.total;
                })
            },

            async queryDetail(id) {
                this.formDisable = true;
                await this.queryDetailOper(id);
                that.activeTab = 'tab_2';
            },

            queryAddsubRecordOper(assessmentid) {
                return AssessmentServer.addsubRecord.list({assessmentid: assessmentid});
            },

            async queryDetailOper(id) {
                let assessmentDetail = await AssessmentServer.assessment.get(id);
                that.assessmentDetail = assessmentDetail.data.data;
                let addsubRecordTableData = await this.queryAddsubRecordOper(that.assessmentDetail.id);
                that.addRecordTableData = addsubRecordTableData.data.data.filter(e => e.config.type == 'add');
                that.subRecordTableData = addsubRecordTableData.data.data.filter(e => e.config.type == 'sub');
            },

            afterUpdateAssessmentRecord() {
                this.$refs.assessmentLevel1Table.queryAssetmentRecordLevel1Table(this.assessmentDetail.id);
                this.queryDetailOper(this.assessmentDetail.id);
                this.queryTable();
            },

            async afterUpdateAddsubRecord() {
                await this.queryDetailOper(this.assessmentDetail.id);
                that.activeTab = 'tab_4';
                this.queryTable();
            },

            btnNewClickHandle() {

                this.formDisable = false;

                this.$refs['assessmentWorkflowInfo'].historyList = [];

                this.$refs['assessmentDetailForm'].resetFields();

                this.level1TableTotal = 0;

                this.assessmentDetail.status = 'DRAFT';

                //获取当前活动的版本号
                AssessmentServer.assessmentVersion.list({}).then((responseBody) => {
                    let versionArr = responseBody.data.data.filter(e => {
                        return e.status == 'ACTIVE';
                    });
                    if (versionArr != null && versionArr.length > 0) {
                        this.assessmentDetail.assessmentobj = '';
                        this.assessmentDetail.month = '';
                        this.assessmentDetail.capacityratio = '';
                        this.assessmentDetail.growupratio = '';
                        this.assessmentDetail.version = versionArr[0].version;
                        this.assessmentDetail.dealperson = localStorage.getItem("realname");
                        this.assessmentDetail.dealdate = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                        this.assessmentDetail.id = -1;
                        this.addRecordTableData = null;
                        this.subRecordTableData = null;

                        //考核时段应该根据当前日期判断，默认展示上一个季度的月份
                        let {year, month} = DateUtil.getNowYearMonthDay();
                        this.assessmentDetail.month = DateUtil.getPreviousQuarterEndMonth(year, month);

                        this.activeTab = 'tab_2';
                    } else {
                        this.$message.error('当前无活动配置版本');
                    }
                });

            },

            btnSaveClickHandle() {
                this.$refs['assessmentDetailForm'].validate((valid) => {
                    if (valid) {
                        if (this.assessmentDetail.id == -1) {
                            AssessmentServer.assessment.add(this.assessmentDetail).then(res => {
                                if (res.data.code == 200) {
                                    this.assessmentDetail = res.data.data;
                                    this.queryDetail(this.assessmentDetail.id);
                                    this.$message.success("新建机房监察成功");
                                    this.queryTable();
                                    this.tab2ButtonControlFunc();
                                    this.formDisable = true;
                                } else {
                                    this.$message.error(res.data.message || "新建机房监察失败");
                                }
                            });
                        } else {
                            AssessmentServer.assessment.update(this.assessmentDetail.id, this.assessmentDetail).then(res => {
                                if (res.data.code == 200) {
                                    this.$message.success("更新机房监察成功");
                                    this.modiBtnVisible = true;
                                    this.cancelVisible = false;
                                    this.queryTable();
                                    this.tab2ButtonControlFunc();
                                    this.formDisable = true;
                                } else {
                                    this.$message.error(res.data.message);
                                }
                            });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },

            btnDelClickHandle() {
                // if (this.$refs.avdRef.assessmentVersionDetail.status != 'DRAFT') {
                //     this.$message.error("非草稿状态禁止删除");
                // } else {

                if(this.$refs['assessmentWorkflowInfo'].historyList.length != 0){
                    this.$message.error("任务已进工作流，无法删除");
                    return;
                }

                this.$confirm('删除此考评记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    AssessmentServer.assessment.delete(this.assessmentDetail.id).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success("删除机房监察记录成功");
                            this.queryTable();
                            this.activeTab = 'tab_1';
                        } else {
                            this.$message.error("\"删除机房监察记录失败:" + res.data.message);
                        }
                    });
                }).catch(() => {
                    console.log('已取消删除');
                });
                // }
            },

            btnModiClickHandle() {
                this.formDisable = false;
                this.modiBtnVisible = false;
                this.cancelVisible = true;
            },

            btnCancelClickHandle() {
                this.formDisable = true;
                this.modiBtnVisible = true;
                this.cancelVisible = false;
                if (this.assessmentDetail.id != -1) {
                    this.queryDetail(this.assessmentDetail.id);
                }
            },

            showCapacityDialog() {
                this.capacityDialogVisible = true;
            },

            showGrowupDialog() {
                this.growupDialogVisible = true;
            },

            //startdate-部门的起始运营时间,pgdate-评估日期
            async setGrowupRatio(startdate, pgdate) {
                //修改为按相差月份计算
                let result = 0;
                let months = DateUtil.getMonthsBetween(startdate, pgdate);

                let groupRatioFomulaInfoList = await DomainalnApi.list({domainid: "GROUPRATIOFOMULA"});
                for (let i = 0; i < groupRatioFomulaInfoList.length; i++) {
                    let fomula = groupRatioFomulaInfoList[i].value;
                    let growUpRatio = groupRatioFomulaInfoList[i].description;
                    fomula = fomula.replace(/\?/g, months);
                    if (eval(fomula)) {
                        result = growUpRatio;
                        break;
                    }
                }

                this.assessmentDetail.growupratio = Number(result);

                // let days = DateUtil.getDaysBetween(startdate, pgdate);    //部门的起始运营时间与评估日期相差天数
                // if (days <= Math.round(365 / 2)) {
                //     growupratio = 1.05;
                // } else if (days > Math.round(365 / 2) && days <= 365) {
                //     growupratio = 1.02;
                // } else {
                //     growupratio = 1;
                // }
            },

            async setCapacityRatio(deptId) {
                let sysroomInfo = await AthubCloudApi.fetchAllSysroomList();
                this.assessmentDetail.capacityratio = await getCapacityRatioOper(sysroomInfo, deptId);
            },

            afterQueryAssessmentRecordLevel1Table(total) {
                this.level1TableTotal = total;
            },

            afterRequestWorkflowFunc(params) {
                this.workflowRequestInfo = params;
                this.workflowDialogVisible = true;
            },

            afterAuditWorkflowFunc(params) {
                AssessmentServer.assessment.workflowAudit(params).then((responseBody) => {
                    this.$refs['assessmentWorkflowInfo'].getHistoryList();
                    this.queryDetail(params.bussinessId);
                    that.$refs.workflowDialog.close();
                    this.queryTable();
                });
            },

            assessmentStatusLoaded(assessmentStatus) {
                let key = assessmentStatus.valueKey;
                let value = assessmentStatus.textKey;
                let dictionary = new Map();
                assessmentStatus.items.forEach(e => {
                    dictionary.set(e[key], e[value]);
                })
                this.assessmentStatusDictionary = dictionary;
            },

            addValueFunc() {
                return this.computerFunc(this.addRecordTableData);
            },

            subValueFunc() {
                return this.computerFunc(this.subRecordTableData);
            },

            computerFunc(tableData) {
                let resultValue = 0;
                if (tableData != null) {
                    resultValue = tableData.reduce(function (sum, item) {
                        return sum + item.score;
                    }, 0);
                }
                return Math.round(resultValue * 100) / 100;
            },

            monthChangeFunc(value){
                let startdate = this.$refs.growupRef.tableData2.filter(e => {
                    return e.id == this.assessmentDetail.assessmentobj
                })[0].startdate;
                this.setGrowupRatio(startdate, value);
            },

            assessmentObjChangeFunc(value) {
                // let {year, month} = this.getNowYearMonth();
                // this.assessmentDetail.month = DateUtil.getPreviousQuarterEndMonth(year, month);

                // this.assessmentDetail.month = '';

                this.monthChangeFunc(this.assessmentDetail.month);
            },

            tab2ButtonControlFunc() {
                if (this.assessmentDetail.id == -1) {
                    this.addBtnVisible = false;
                    this.modiBtnVisible = false;
                    this.cancelVisible = false;
                    this.reviseBtnVisible = false;
                    this.saveBtnVisible = true;
                    this.delBtnVisible = false;
                    this.dropDownVisible = false;
                    this.workflowBtnVisible = false;
                    this.workflowStatusVisible = true;
                } else {
                    this.addBtnVisible = true;
                    this.modiBtnVisible = true;
                    this.cancelVisible = false;
                    this.reviseBtnVisible = false;
                    this.saveBtnVisible = true;
                    this.delBtnVisible = true;
                    this.dropDownVisible = false;
                    this.workflowBtnVisible = true;
                    this.workflowStatusVisible = true;
                }
            },

            formatMonth(row, column) {
                let dateArr = row[column.property].split('-');
                return dateArr[0] + '-' + dateArr[1];
            },
        },

        filters: {

            statusFilter(value) {
                return that.transferValue2Desc(that.assessmentVersionStatus, value) || '';
            },

            deptFilter(value) {
                return that.transferDeptId2Name(that.$refs.deptSelectTable.deptList, value) || '';
            },

            workflowStatusLabelFilter(value) {
                if (value != '' && that.assessmentStatusDictionary != null) {
                    return that.assessmentStatusDictionary.get(value);
                }
                return "草稿";
            }

        },

        created() {
            that = this;
        },

        mounted() {

            if (this.$route.query.source === 'index') {
                AthubCloudApi.fetchCurrentTaskIds('INSPECT').then(res => {
                    if(res.length > 0){
                        this.searchParams.ids = res;
                        this.queryTable();
                    }
                });
            } else {
                this.queryTable();
            }

        },

        watch: {

            pageSize: {
                handler() {
                    this.queryTable();
                },
            },

            currentPage: {
                handler() {
                    this.queryTable();
                },
            },

            searchParams: {
                deep: true,
                handler: debounce(function (newVal, oldVal) {
                    this.total = 0;
                    this.tableData = [];
                    this.currentPage = 1;
                    this.queryTable();
                }, 500)
            },

            activeTab: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal == 'tab_1') {
                        this.addBtnVisible = true;
                        this.modiBtnVisible = false;
                        this.cancelVisible = false;
                        this.reviseBtnVisible = false;
                        this.saveBtnVisible = false;
                        this.delBtnVisible = false;
                        this.dropDownVisible = true;
                        this.workflowBtnVisible = false;
                        this.workflowStatusVisible = false;
                    } else if (newVal == 'tab_2') {
                        this.tab2ButtonControlFunc();
                    } else {
                        this.addBtnVisible = false;
                        this.modiBtnVisible = false;
                        this.cancelVisible = false;
                        this.reviseBtnVisible = false;
                        this.saveBtnVisible = false;
                        this.delBtnVisible = false;
                        this.dropDownVisible = false;
                        this.workflowBtnVisible = false;
                        this.workflowStatusVisible = false;
                    }

                    // this.formDisable = true;

                    if (this.hasPermission(ASSESSMENT_PERMISSION)) {
                        this.canOper = true;
                    } else {
                        this.canOper = false;
                    }

                }
            },

            assessmentObj: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.setCapacityRatio(newVal);
                    }
                }
            },

            workflowStatus: {
                handler: function (newVal, oldVal) {
                    if (newVal == 'DRAFT') {
                        this.isInWorkflow = false;
                    } else {
                        this.isInWorkflow = true;
                    }
                }
            },

        },

        computed: {

            assessmentObj() {
                this.resultScoreContent = '最终得分=分项测评得分*容量系数*成长系数+加分项得分+减分项得分';
                this.resultScoreContent += "=" + this.level1TableTotal + "*" + this.assessmentDetail.capacityratio + "*" + this.assessmentDetail.growupratio + "+" + this.addValueFunc() + "+" + this.subValueFunc();

                if (this.assessmentDetail.status == 'DRAFT') {  //草稿状态时，从配置中读取，否则从固化记录中读取容量系数与成长系数
                    return this.assessmentDetail.assessmentobj;
                }
            },

            workflowStatus() {
                return this.assessmentDetail.status;
            },

            totalscore() {
                let addTotalValue = this.addValueFunc();
                let subTotalValue = this.subValueFunc();
                this.addsubTotal = Math.round((addTotalValue + subTotalValue) * 100) / 100;;
                //最终得分由变更为：分项测评得分*容量系数*成长系数+加分项得分+减分项得分
                let score = ((parseFloat(this.level1TableTotal) * this.assessmentDetail.capacityratio * this.assessmentDetail.growupratio + parseFloat(addTotalValue) + parseFloat(subTotalValue)) * 100) / 100;
                score =  Math.round(score * 100) / 100;
                if(score < 0){
                    score = 0;
                }
                this.assessmentDetail.totalscore = score;
                return score;
            },

        }
    }
</script>

<style scoped>

</style>